import { AmpereUnit } from '@/entities/ampere-unit';

export function dynamicAmpereUnit(a: number): AmpereUnit {
  if (a === 0) return AmpereUnit.A;

  const unit = Math.floor(Math.log10(Math.abs(a)) / 3);

  if (unit <= 0) return AmpereUnit.A;
  if (unit === 1) return AmpereUnit.KA;
  return AmpereUnit.MA;
}
